import WsProvider from './provider/WSProvider'
var base64 = require('base64_js');
var serviceName = "islem";
var seoService = {
    islemListesi(baslangic, limit) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                baslangic: 0,
                limit: 10,
                methodName: "islemListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default seoService

